import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ServiceFeedbackCustomerRecord } from '@navio/nsdk';
import { NoddiButton, NoddiDialog, NoddiTextArea } from 'noddi-ui-web';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';
import { useState } from 'react';
import { RatingComponent } from './RatingComponent';

interface ViewFeedbackModalProps {
  feedback: ServiceFeedbackCustomerRecord;
}

export const ViewFeedbackModal = ({ feedback }: ViewFeedbackModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const feedbackDate = noddiFormatDate(feedback.createdAt, NoddiDateFormats.DATE_TIME);

  return (
    <>
      <NoddiButton variant='outline' size='small' onClick={() => setIsOpen(true)}>
        <Trans>View feedback</Trans>
      </NoddiButton>

      <NoddiDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title={t`Your feedback`}
        description={t`Given on ${feedbackDate}`}
      >
        <div className='flex flex-col gap-5'>
          <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
            <RatingComponent
              rating={feedback.customerRatingOverall}
              label={t`Overall experience`}
              readOnly
              showDivider={false}
            />
            <RatingComponent
              rating={feedback.customerRatingCarResult}
              label={t`Result of the service`}
              readOnly
              showDivider={false}
            />
            <RatingComponent
              rating={feedback.customerRatingCommunication}
              label={t`Communication`}
              readOnly
              showDivider={false}
            />
            <RatingComponent
              rating={feedback.customerRatingEaseOfUse}
              label={t`Ease of booking`}
              readOnly
              showDivider={false}
            />
            {feedback.customerRatingPoliteness && (
              <RatingComponent
                rating={feedback.customerRatingPoliteness}
                label={t`Politeness`}
                readOnly
                showDivider={false}
              />
            )}
          </div>

          {feedback.customerComment && (
            <div className='flex flex-col gap-2'>
              <span className='text-sm font-medium text-muted-foreground'>
                <Trans>Your comment</Trans>
              </span>
              <NoddiTextArea value={feedback.customerComment} readOnly className='resize-none' rows={3} />
            </div>
          )}
        </div>
      </NoddiDialog>
    </>
  );
};
